import { cn } from '@/lib/cn';

export function Rating({
  value,
  count,
  size = 'sm',
  className,
}: {
  value: number;
  count?: number;
  size?: 'sm' | 'md';
  className?: string;
}) {
  const rounded = Math.round(value * 10) / 10;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 font-medium text-ink-900',
        size === 'sm' ? 'text-sm' : 'text-base',
        className,
      )}
    >
      <svg
        viewBox="0 0 20 20"
        aria-hidden
        className={cn('text-amber-500', size === 'sm' ? 'h-4 w-4' : 'h-5 w-5')}
        fill="currentColor"
      >
        <path d="M10 1.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L10 15l-5.2 2.6 1-5.8L1.5 7.7l5.9-.9L10 1.5z" />
      </svg>
      {count === 0 ? (
        <span className="whitespace-nowrap font-normal text-ink-400">Nouveau</span>
      ) : (
        <>
          {rounded.toLocaleString('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}
          {count !== undefined && <span className="font-normal text-ink-500">({count})</span>}
        </>
      )}
    </span>
  );
}

/** Sélecteur d'étoiles pour les formulaires d'avis. */
export function RatingInput({
  value,
  onChange,
  label,
}: {
  value: number;
  onChange: (value: number) => void;
  label: string;
}) {
  return (
    <div className="flex items-center justify-between gap-4 py-1.5">
      <span className="text-sm text-ink-700">{label}</span>
      <div className="flex gap-0.5">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            type="button"
            aria-label={`${star} sur 5`}
            onClick={() => onChange(star)}
            className="rounded p-0.5"
          >
            <svg
              viewBox="0 0 20 20"
              className={cn('h-6 w-6', star <= value ? 'text-amber-500' : 'text-ink-200')}
              fill="currentColor"
            >
              <path d="M10 1.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L10 15l-5.2 2.6 1-5.8L1.5 7.7l5.9-.9L10 1.5z" />
            </svg>
          </button>
        ))}
      </div>
    </div>
  );
}
